import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';

import { NioSection } from './index';
import NioIcon from './NioIcon/NioIcon';
import { useTranslation } from '../i18n/I18nProvider';
import { translateCategory, translateServiceLabel } from '../i18n/translateService';
import { api } from '../utils/api';

function ServiceDetailsSection({ categoryId, serviceTitle }) {
  const { t, language } = useTranslation();
  const [otherServices, setOtherServices] = useState([]);

  const serviceName = categoryId
    ? translateCategory(t, categoryId).toLowerCase()
    : translateServiceLabel(t, serviceTitle).toLowerCase();

  useEffect(() => {
    const fetchOtherServices = async () => {
      try {
        const res = await api.getServices({});
        if (res?.success && Array.isArray(res.data)) {
          const active = res.data.filter(s => s.isActive !== false && s.title !== serviceTitle);
          const picked = active.slice(0, 4).map(s => ({
            key: s.slug || s.tilePrefix || s._id,
            cover: s.cover || '/images/blog/a.jpg',
            to: `/services/${s.slug || s._id}`,
            label: s.titles?.[language] || s.title,
          }));
          setOtherServices(picked);
        }
      } catch {
        // ignore
      }
    };
    fetchOtherServices();
  }, [serviceTitle]);

  const expertLeftKeys = ['expert1', 'expert2', 'expert3'];
  const expertRightKeys = ['expert4', 'expert5', 'expert6'];

  return (
    <NioSection className="py-5">
      <NioSection.Content>
        <style>{`
        .service-details-experts__mediaWrap {
          position: relative;
          max-width: 300px;
        }
        .service-details-experts__media {
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
        }
        .service-details-experts__media img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          display: block;
        }
        .service-details-experts__mediaBadge {
          position: absolute;
          top: -12px;
          left: -12px;
          width: 44px;
          height: 44px;
          border-radius: 10px;
          background: #1d72c9;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 18px rgba(29, 114, 201, 0.3);
        }
        .service-details-experts__mediaBadge img {
          width: 24px;
          height: 24px;
          object-fit: contain;
          filter: brightness(0) invert(1);
        }
        .service-details-feature__icon {
          width: 30px;
          height: 30px;
          object-fit: contain;
          margin: 0 auto 0.6rem;
          display: block;
        }
          .service-details-experts__title {
            color: #0f2b46;
            font-weight: 700;
            font-size: clamp(1.2rem, 1.7vw, 1.6rem);
            line-height: 1.22;
            margin-bottom: 1.1rem;
            max-width: 760px;
          }
          .service-details-experts__list {
            list-style: none;
            padding: 0;
            margin: 0;
            display: grid;
            gap: 0.95rem;
          }
          .service-details-experts__item {
            position: relative;
            padding-left: 2rem;
            color: #0f2b46;
            line-height: 1.6;
            font-size: 1.05rem;
          }
          .service-details-experts__item::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0.32rem;
            width: 16px;
            height: 16px;
            border: 2px solid #3b82f6;
            border-radius: 2px;
            background: #fff;
          }
          .service-details-experts__item::after {
            content: "\e9be";
            font-family: "Nioicon";
            position: absolute;
            left: 2px;
            top: 0.02rem;
            color: #2563eb;
            font-weight: 700;
            font-size: 0.9rem;
          }
          .service-details-process {
            margin-top: 3rem;
            padding-top: 2rem;
            border-top: 1px solid #e5e7eb;
          }
          .service-details-process__title {
            color: #12314f;
            font-weight: 700;
            text-align: center;
            margin-bottom: 1.8rem;
          }
          .service-details-process__icon {
            width: 110px;
            height: 64px;
            object-fit: contain;
            display: block;
            margin: 0 auto 0.8rem;
          }
          .service-details-process__stepTitle {
            color: #12314f;
            font-size: 1.25rem;
            font-weight: 700;
            margin-bottom: 0.45rem;
          }
          .service-details-process__stepText {
            color: #475569;
            line-height: 1.55;
            margin-bottom: 0;
          }
          .service-details-process__reviews {
            margin-top: 1.8rem;
          }
          .service-details-process__review {
            border: 1px solid #e5e7eb;
            border-radius: 10px;
            padding: 0.8rem;
            height: 100%;
            background: #fff;
          }
          .service-details-process__stars {
            color: #10b981;
            font-size: 0.9rem;
            font-weight: 700;
          }
          .service-details-process__reviewText {
            color: #334155;
            font-size: 0.9rem;
            margin: 0.45rem 0 0;
          }
          .service-details-reasons {
            margin-top: 2.8rem;
            padding-top: 2rem;
            border-top: 1px solid #e5e7eb;
          }
          .service-details-reasons__title {
            text-align: center;
            color: #0f2b46;
            font-weight: 700;
            margin-bottom: 1.6rem;
          }
          .service-details-reasons__icon {
            width: 28px;
            height: 28px;
            object-fit: contain;
            margin-bottom: 0.8rem;
          }
          .service-details-reasons__itemTitle {
            color: #0f2b46;
            font-size: 1.8rem;
            font-weight: 700;
            margin-bottom: 0.65rem;
          }
          .service-details-reasons__text {
            color: #475569;
            line-height: 1.7;
            margin-bottom: 0;
          }
          .service-details-other {
            margin-top: 2.8rem;
            padding-top: 2rem;
            border-top: 1px solid #e5e7eb;
          }
          .service-details-other__title {
            text-align: center;
            color: #0f2b46;
            font-weight: 700;
            margin-bottom: 1.6rem;
          }
          .service-details-other__card {
            display: block;
          }
          .service-details-other__thumb {
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
            margin-bottom: 0.75rem;
          }
          .service-details-other__thumb img {
            width: 100%;
            height: 140px;
            object-fit: cover;
            display: block;
          }
          .service-details-other__label {
            color: #245a95;
            text-decoration: underline;
            font-size: 1.35rem;
            line-height: 1.35;
          }
        `}</style>
        <Row className="justify-content-center">
          <Col lg={10}>
            <h3 className="mb-3">{t('serviceCatalog.details.ourServices', { service: serviceName })}</h3>
            <p className="text-muted mb-3">{t('serviceCatalog.details.welcome1', { service: serviceName })}</p>
            <p className="text-muted mb-4">{t('serviceCatalog.details.welcome2')}</p>
          </Col>
        </Row>

        <Row className="g-4 text-center mb-4">
          <Col sm={6} lg={3}>
            <img src="/images/publiez.svg" alt="" className="service-details-feature__icon" />
            <h6 className="mb-2 text-primary">{t('serviceCatalog.details.transparentPricing')}</h6>
            <p className="text-muted mb-0">{t('serviceCatalog.details.transparentPricingDesc')}</p>
          </Col>
          <Col sm={6} lg={3}>
            <img src="/images/prestataire.svg" alt="" className="service-details-feature__icon" />
            <h6 className="mb-2 text-primary">{t('serviceCatalog.details.verifiedProviders')}</h6>
            <p className="text-muted mb-0">{t('serviceCatalog.details.verifiedProvidersDesc')}</p>
          </Col>
          <Col sm={6} lg={3}>
            <img src="/images/satisfer.sg.webp" alt="" className="service-details-feature__icon" />
            <h6 className="mb-2 text-primary">{t('serviceCatalog.details.satisfiedOrRedone')}</h6>
            <p className="text-muted mb-0">{t('serviceCatalog.details.satisfiedOrRedoneDesc')}</p>
          </Col>
          <Col sm={6} lg={3}>
            <img src="/images/assurance.png" alt="" className="service-details-feature__icon" />
            <h6 className="mb-2 text-primary">{t('serviceCatalog.details.insuranceIncluded')}</h6>
            <p className="text-muted mb-0">{t('serviceCatalog.details.insuranceIncludedDesc')}</p>
          </Col>
        </Row>

        <Row className="align-items-start g-4 g-lg-5 pt-2">
          <Col lg={4}>
            <div className="service-details-experts__mediaWrap">
              <span className="service-details-experts__mediaBadge" aria-hidden>
                <img src="/images/publiez.svg" alt="" />
              </span>
              <div className="service-details-experts__media">
                <img src="/images/img.jpg" alt={serviceName} />
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <h4 className="service-details-experts__title">
              {t('serviceCatalog.details.expertsTitle', { service: serviceName })}
            </h4>
            <ul className="service-details-experts__list">
              {expertLeftKeys.map((key) => (
                <li key={key} className="service-details-experts__item">
                  {t(`serviceCatalog.details.${key}`, { service: serviceName })}
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={4}>
            <ul className="service-details-experts__list">
              {expertRightKeys.map((key) => (
                <li key={key} className="service-details-experts__item">
                  {t(`serviceCatalog.details.${key}`)}
                </li>
              ))}
            </ul>
          </Col>
        </Row>

        <div className="service-details-process">
          <Row className="justify-content-center">
            <Col lg={10}>
              <h4 className="service-details-process__title">{t('serviceCatalog.details.processTitle')}</h4>
            </Col>
          </Row>
          <Row className="g-4">
            {['step1', 'step2', 'step3', 'step4'].map((step) => (
              <Col sm={6} lg={3} key={step}>
                <img src={`/images/${step === 'step1' ? 'publiez' : step === 'step2' ? 'recevez' : step === 'step3' ? 'assurance' : 'prestataire'}.svg`} alt="" className="service-details-process__icon" />
                <h6 className="service-details-process__stepTitle">{t(`serviceCatalog.details.${step}Title`)}</h6>
                <p className="service-details-process__stepText">{t(`serviceCatalog.details.${step}Text`)}</p>
              </Col>
            ))}
          </Row>
          <Row className="service-details-process__reviews g-3">
            {[
              ['reviewExcellent', 'reviewExcellentText'],
              ['reviewVerified1', 'reviewVerified1Text'],
              ['reviewVerified2', 'reviewVerified2Text'],
              ['reviewVerified3', 'reviewVerified3Text'],
            ].map(([starsKey, textKey]) => (
              <Col sm={6} lg={3} key={starsKey}>
                <div className="service-details-process__review">
                  <div className="service-details-process__stars d-inline-flex gap-1" style={{ color: '#f59e0b' }}>
                    {[1, 2, 3, 4, 5].map((n) => <NioIcon key={n} name="star-fill" />)}
                  </div>
                  <span className="ms-2">{t(`serviceCatalog.details.${starsKey}`)}</span>
                  <p className="service-details-process__reviewText">{t(`serviceCatalog.details.${textKey}`)}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <div className="service-details-reasons">
          <h4 className="service-details-reasons__title">{t('serviceCatalog.details.reasonsTitle')}</h4>
          <Row className="g-4">
            {['reason1', 'reason2', 'reason3'].map((reason, i) => (
              <Col md={4} key={reason}>
                <img src={`/images/${['verifie.png', 'avis.jpg.png', 'free.png'][i]}`} alt="" className="service-details-reasons__icon" />
                <h5 className="service-details-reasons__itemTitle">{t(`serviceCatalog.details.${reason}Title`)}</h5>
                <p className="service-details-reasons__text">{t(`serviceCatalog.details.${reason}Text`)}</p>
              </Col>
            ))}
          </Row>
        </div>

        <div className="service-details-other">
          <h4 className="service-details-other__title">{t('serviceCatalog.details.otherServicesTitle')}</h4>
          <Row className="g-4">
            {otherServices.map((item) => (
              <Col sm={6} lg={3} key={item.key}>
                <Link to={item.to} className="service-details-other__card">
                  <div className="service-details-other__thumb">
                    <img src={item.cover} alt={item.label} />
                  </div>
                  <span className="service-details-other__label">{item.label}</span>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      </NioSection.Content>
    </NioSection>
  );
}

export default ServiceDetailsSection;
